var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticStyle:{"opacity":"0.5"}},[_vm._v(" "+_vm._s(_vm.translate("label.created"))+": "),_c('Date',{attrs:{"date":_vm.study.created}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }